import { CommonModule, isPlatformBrowser, Location } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from "@angular/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { RouterModule, ActivatedRoute,Router } from "@angular/router";
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { ChooseLocationModalComponent } from "../../../shared/components/choose-location-modal/choose-location-modal.component";
import { AnalyticsService } from "../../../shared/services/analytics.service";
import { CartDetailsService } from "../../../shared/services/cart-details.service";
import { CartService } from "../../../shared/services/cart.service";
import { DataLayerService } from "../../../shared/services/gtm-service/data-layer.service";
import { JsonDataService } from "../../../shared/services/json-data.service";
import { MetaMgmtService } from "../../../shared/services/meta-mgmt.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { CartComponent } from "../../../shared/components/cart/cart.component";
import { OrderSummaryComponent } from "../order-summary/order-summary.component";
import { TruncatePipe } from "../../../shared/pipes/truncate.pipe";

@Component({
  selector: 'app-cart-details',
  standalone: true,
  imports: [CommonModule, RouterModule, TruncatePipe, CartComponent, OrderSummaryComponent,MatDialogModule],
  templateUrl: './cart-details.component.html',
  styleUrl: './cart-details.component.scss'
})
export class CartDetailsComponent implements OnInit, OnDestroy {
  environment: any = environment;
  cartInfo$: any = [];
  sub:Subscription=new Subscription()

  orderDetails: any;
  pinCode: any;

  constructor(public utils: UtilsService,private dataLayerService:DataLayerService,private analyticsService: AnalyticsService, public cartDetailService: CartDetailsService, public service: CartService, public cartService: CartDetailsService, public dialog: MatDialog, public router: Router, public _location: Location, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService) {
    this.pinCode = this.utils.getUserPicode();
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
    },
    error: (err: any) => {
      this.utils.hideLoading()
      console.error('Error fetching meta data', err);
    }}));
    this.utils.showHeaderFooter.next(true);
  }

  ngOnInit() {
    this.sub.add(this.service.cartData$.subscribe(
      (data: any) => {
        this.utils.hideLoading();
        this.cartInfo$ = data ? data : []
        this.getOrderTotal()
      }))
    this.getCartItems();
    this.dataLayerService.triggerCartEvents('view_cart')
  }

  getCartItems() {
    this.service.loadInfo()
    if (this.utils.getToken()) {
      this.sub.add( this.service.getItems().subscribe({
        next: (response: any) => {
          if (response.success) {
            if (this.cartInfo$ && this.cartInfo$.length) {
              this.service.processCartItems(this.cartInfo$, response, (updateCart: any) => {
                if (updateCart) {
                  this.sub.add(  this.cartService.checkout().subscribe((data: any) => {
                  }))
                }
              }, (_emptyCart: any) => {
                this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                this.service.clearInfo();
                this.sub.add( this.cartService.checkout().subscribe((data: any) => {
                }))
              },
                false, false, (pincodeDiffers: any) => {
                  this.utils.showLoading();
                  this.cartService.pinCodeChange();
                });
            }
            else {
              if (response.cartDetailList && response.cartDetailList.length) {
                this.utils.setUserPicode(response.cartDetailList[0].pincode);
                this.service.setInfo(response.cartDetailList, false);
              }
            }
            this.utils.hideLoading();
          }
          else {
            if (response && (response.statusCode != "204" && response.message != 'Record not found')) {
              this.service.clearInfo()
              this.utils.openSnackBar(response.message, 'error-toster');
            }
            else {
              if (this.cartInfo$ && this.cartInfo$.length) {
                this.service.processCartItems(this.cartInfo$, response, (updateCart: any) => {
                  if (updateCart) {
                    this.sub.add( this.cartService.checkout().subscribe((data: any) => {
                    }))
                  }
                }, (_emptyCart: any) => {
                  this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                  this.service.clearInfo();
                  this.sub.add( this.cartService.checkout().subscribe((data: any) => {
                  }))
                },
                  false, this.utils.isRecentLogin ? true : false);
              }
            }
            this.utils.hideLoading();
          }
        }
      }))
    }
  }

  getOrderTotal() {
    this.cartInfo$.forEach((element: any) => {
      element.basePrice = ((element.sellingPrice - element.discount) * 100) / (element.taxPercent + 100)
      element.taxAmount = (element.basePrice / 100) * element.taxPercent;
    });
  }

  onProductDelete(product: any) {
    let index:any;
    if (this.cartInfo$) {
      let data = {
        title: 'Delete Product',
        content: 'Are you sure, you want to delete this product ?',
        closeBtnText: "Cancel",
        confirmBtnText: "Delete",
        isConfirmation: true
      }
      this.utils.openConfirmationPopup(data, (res: boolean) => {
        if (res) {
          let found = this.cartInfo$.some((element: any) => product.productGuId == element.productGuId)
          if (found) {
             index = this.cartInfo$.findIndex((element: any) => { return element.productGuId == product.productGuId })
             this.dataLayerService.triggerAddRemoveEvent('remove_from_cart',this.cartInfo$[index])
             if (this.cartInfo$.length > 1) {
              this.cartInfo$.splice(index, 1)
              this.service.setInfo(this.cartInfo$, false)
            }
            else if (this.cartInfo$.length == 1) {
              this.service.clearInfo()
            }
            this.cartDetailService.triggerCartUpdate();
                        if (this.utils.getUser()) {
                          this.sub.add(  this.cartService.checkout().subscribe((data: any) => {
                if (data.success) {
                  this.utils.openSnackBar(data.message, 'success-toster')
                }
                if (!data.success) {
                  this.utils.openSnackBar('Internal server error', 'error-toster')
                }
              }))
            }
          }
        }
      })
    }
  }

  openLocationDialog(): void {
    const dialogRef = this.dialog.open(ChooseLocationModalComponent, {
      disableClose: true,
      panelClass: 'cookiesModel',
      data: this.utils.getUserPicode()
    });
    this.sub.add(  dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.cartService.pinCodeChange();
      }
    }));
  }

  proceedToCheckout() {
    if ((window as any).fbq) {
      (window as any).fbq('track', 'InitiateCheckout');
    } else {
    }
    this.dataLayerService.triggerCartEvents('begin_checkout')
    this.analyticsService.triggerCheckoutStartEvent();
    if (this.utils.getUser()) {
      this.router.navigate(['/checkout/shipping-details'])
    }
    else if (!this.utils.getUser()) {
      this.router.navigate(['/checkout/shipping-details'])
    }
  }

  getPDPLink(productGuid: any, productName: any) {
    if (productGuid || productName) {
      let name: any = this.utils.createNameForUrl(productName);
      return `/product/${name}`
    }
    else {
      return '';
    }
  }

  ngOnDestroy(): void {
    this.utils.discountCouponData.next('');
    this.sub.unsubscribe()
  }
}
